import { render, staticRenderFns } from "./ElementInspector.vue?vue&type=template&id=a09f496a&scoped=true"
import script from "./ElementInspector.vue?vue&type=script&lang=js"
export * from "./ElementInspector.vue?vue&type=script&lang=js"
import style0 from "./ElementInspector.vue?vue&type=style&index=0&id=a09f496a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09f496a",
  null
  
)

export default component.exports